import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/demo/node_modules/@marinda/gatsby-theme-recipes/src/components/MarkdownPagesLayout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Privacy Policy & Cookies`}</h1>
    <p>
      <i>Suspendisse imperdiet est ipsum, at pharetra diam molestie id. Etiam et dui gravida, molestie massa vitae, fringilla tortor. Ut pretium neque sit amet est consequat, quis congue leo fringilla. In in ex magna. Maecenas interdum, ipsum a accumsan pellentesque, sapien orci porta urna, eu molestie lorem eros sed lacus. Suspendisse malesuada congue risus et gravida. Aenean faucibus sit amet nisi ac suscipit. Nullam porta consequat mi, non tincidunt ante hendrerit at. Aenean purus magna, finibus et accumsan eu, finibus eget risus. </i></p>
    <h2>{`Lorem Ipsum`}</h2>
    <p>{`Lorem `}<b>{`Ipsum`}</b>{` carum. Nulla a justo odio. Sed molestie mauris ac nunc laoreet, in blandit felis dapibus.  `}<a parentName="p" {...{
        "href": "#"
      }}>{`Donec in arcu id orci auctor viverra.`}</a>{` claw cupcake jujubes carro.`}</p>
    <h2>{`Lorem`}</h2>
    <ul>
      <li parentName="ul">{`Integer in nisl dapibus.`}</li>
      <li parentName="ul">{`Suspendisse imperdiet est ipsum, at pharetra diam molestie id. Etiam et dui gravida, molestie massa vitae, fringilla tortor. Ut pretium neque sit amet est consequat, quis congue leo fringilla.`}</li>
      <li parentName="ul"><strong parentName="li">{`  Volutpat ipsum et `}</strong></li>
      <li parentName="ul">{`Ultricies lacus.`}</li>
    </ul>
    <h3>{`Ipsum`}</h3>
    <p>{`Integer in nisl dapibus, volutpat ipsum et, ultricies lacus. Proin luctus quis massa mollis euismod. Aliquam eleifend diam sed dui posuere blandit.`}</p>
    <ol>
      <li parentName="ol">{`Mauris tristique ipsum ut enim imperdiet mattis a nec elit.`}</li>
      <li parentName="ol">{`Phasellus sollicitudin urna a rhoncus ullamcorper.`}</li>
      <li parentName="ol"><strong parentName="li">{` Aenean purus magna, finibus et accumsan eu, finibus eget risus.  `}</strong></li>
      <li parentName="ol">{`Donec vestibulum, elit id feugiat viverra, odio diam venenatis lectus, in mattis ante magna ut ante. `}</li>
    </ol>
    <p>{`Nam pretium eros ut dolor tristique placerat. Nunc pulvinar nibh et felis sodales eleifend. Quisque gravida augue non augue semper commodo. `}</p>
    <p>{`In sagittis, purus sed dictum lobortis, massa diam blandit lacus, sed convallis lectus mauris sit amet arcu. Quisque eleifend sem nisi, at dapibus leo ultricies nec. Morbi eu imperdiet sapien. Proin fermentum varius finibus. `}</p>
    <p>{`Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus quis nisi at lectus viverra suscipit eget eget magna. Phasellus mattis, ex sed laoreet mattis, dui felis accumsan nibh, vel sollicitudin massa massa eget lorem. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      